import { statusColor } from '../../utils/httpColors';

interface StatusBadgeProps {
  status: number | null;
}

/** The full code (`404`), coloured by its class (docs/brand.md → Badge style). */
export function StatusBadge({ status }: StatusBadgeProps) {
  if (status === null) {
    return null;
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center px-1.5 py-0.5 rounded-selector font-mono font-medium text-xs ${statusColor(status).badge}`}
    >
      {status}
    </span>
  );
}
